import { useState, useEffect } from "react";

import inBrowser from "../helpers/inBrowser";

// OneTrust Cookie Categories
export const COOKIE_CATEGORIES = {
  performanceCookieGroup: "C0002",
};

export const CONSENT_STATUS = {
  consentNotGiven: 0,
  consentGiven: 1,
};

const getConsentStatus = (categoryId) => {
  if (window.OnetrustActiveGroups.includes(categoryId)) {
    return CONSENT_STATUS.consentGiven;
  }
  return CONSENT_STATUS.consentNotGiven;
};

export default function useConsentStatus(categoryId) {
  const [consentStatus, setConsentStatus] = useState();
  const isOneTrustInitialized = inBrowser() && !!window.OneTrust;

  useEffect(() => {
    let isCurrent = true;
    if (isOneTrustInitialized) {
      setConsentStatus(getConsentStatus(categoryId));

      window.OptanonWrapper = () => {
        if (isCurrent) {
          setConsentStatus(getConsentStatus(categoryId));
        }
      };
    }

    return () => {
      isCurrent = false;
    };
  }, [categoryId, isOneTrustInitialized]);

  return consentStatus;
}
